import React from "react";
import { OverflowText } from "@widgets/datadisplay/overflowtext";
import PropTypes from "kf-proptypes/widgets";
import {
  KfIcon,
  KF_ICONS,
  ICON_SIZE,
  ICON_STROKE
} from "@widgets/common/components/primitives/kf_icon";

import { BaseDropdown } from "../base.jsx";

import styles from "./style.css";

//import DownArrowIcon from "../inlinedropdown/DownArrow.svg";

export const SIMPLE_DROPDOWN_TYPE = {
  BASE: "base",
  MEDIUM: "medium",
  SMALL: "small"
};

SimpleDropdown.propTypes = {
  /**
   * To customise the dropdown list
   */
  listRenderer: PropTypes.func,
  /**
   * value for the simple dropdown
   */
  value: PropTypes.string.isRequired,
  /**
   * Default value for the dropdown
   */
  defaultValue: PropTypes.string,
  /**
   * paddingNone value for the dropdown target renderer padding
   */
  paddingNone: PropTypes.bool,
  /**
   * size value for the dropdown size
   */
  size: PropTypes.oneOf(Object.values(SIMPLE_DROPDOWN_TYPE)),
  /**
   * errors value for error handle
   */
  errors: PropTypes.arrayOf(PropTypes.string)
};

/**
 * Use this component to show the Dropdown with simple dropdown type list
 */

const SIMPLE_DROPDOWN_ICON_SIZE = {
  [SIMPLE_DROPDOWN_TYPE.BASE]: ICON_SIZE.SIZE_16,
  [SIMPLE_DROPDOWN_TYPE.MEDIUM]: ICON_SIZE.SIZE_12,
  [SIMPLE_DROPDOWN_TYPE.SMALL]: ICON_SIZE.SIZE_12
};

export function SimpleDropdown(props) {
  const {
    value,
    defaultValue,
    listRenderer,
    paddingNone = false,
    size = SIMPLE_DROPDOWN_TYPE.SMALL,
    errors = [],
    ...restProps
  } = props;

  return (
    <BaseDropdown
      targetRenderer={() => {
        return (
          <div
            className={`${styles.targetRenderContainer}  ${styles[size]} ${
              paddingNone && styles.targetRenderContainerPadding
            }   ${errors.length && styles.targetRenderContainerError}`}
            tabIndex={"1"}
          >
            <OverflowText className={`${styles.selectedValue} `}>
              {value || defaultValue}
            </OverflowText>
            <KfIcon
              icon={KF_ICONS.ARROW_DOWN_SIMPLE}
              size={SIMPLE_DROPDOWN_ICON_SIZE[size]}
              stroke={ICON_STROKE.THIN}
            />
          </div>
        );
      }}
      listRenderer={listRenderer}
      {...restProps}
    />
  );
}
